<template>
  <div class="main-content">
    <div class="top">
      <div class="position-type">
        <div class="top-title">
          <div class="left">
            <div class="text">职位类别</div>
            <div class="show-more-icon v1" :class="{ 'gray': isShowFirst }"  @click="showPosition('toLeft')">
              <div class="circle-bg">
                <img src="../../assets/white_right_arrow.png" alt="">
              </div>
            </div>
            <div class="show-more-icon" :class="{ 'gray': !isShowFirst }" @click="showPosition('toRight')">
              <div class="circle-bg">
                <img src="../../assets/white_right_arrow.png" alt="">
              </div>
            </div>
          </div>
          <div class="right-img">
            <img src="../../assets/position_type.png" alt="">
          </div>
        </div>
        <div class="position-list">
          <div class="position-item" v-for="(item, index) in recruitHotList" :key="index" @click="toPositionList(item)">
            {{ item.aliasName }}
          </div>
        </div>
      </div>
      <div class="top-banner">
        <div class="banner-img">
          <div v-if="!bannerList || bannerList.length == 0" class="default-bg"></div>
          <el-carousel v-else :interval="bannerInterval" arrow="never" :autoplay="true" @change="changeBanner"
            ref="carouselRef">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <img :src="item.img_url" alt="" @click="toJump(item.jump_link)">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="item-text">
          <div class="text" :class="{ 'active': bannerActiveIndex === index }" v-for="(item, index) in bannerList"
            :key="index" @click="setActiveItem(index)">
            <div class="content" :style="{ maxWidth: bannerMaxWidth + 'px' }">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="companyFamousList && companyFamousList.length" class="hot-company">
      <div class="title">名企急聘</div>
      <div class="hot-company-list">
        <div class="hot-company-item" v-for="(item, index) in companyFamousList" :key="index"
          @click="toJump(item.jump_link)">
          <div class="top-img">
            <div v-if="!item.img_url" class="default-bg"></div>
            <img v-else :src="item.img_url" alt="">
          </div>
          <div class="bottom-title">
            <img class="icon" src="../../assets/icon_hot_company.png" alt="" srcset="">
            <div class="text">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="companyList && companyList.length" class="company">
      <div class="title">招聘企业</div>
      <div class="company-list">
        <div class="company-item" v-for="(item, index) in companyList" :key="index" @click="toCompany(item)">
          <div v-if="!item.logo_url" class="company-item-img-bg"></div>
          <img v-else class="company-item-img" :src="item.logo_url" alt="">
          <div class="company-name">{{ item.company_name }}</div>
        </div>
        <div class="company-item v1" @mousemove="companyIsMouse = true" @mouseleave="companyIsMouse = false"
          @click="toCompanyList">
          <div class="content-box">
            <img class="company-item-img" src="../../assets/image/more_company_btn.png" alt="">
            <div class="company-name">更多企业</div>
            <div class="more-icon">
              <img :src="moreCompanyArrow" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPositionList && showPositionList.length" class="position">
      <div class="title">招聘职位</div>
      <div class="position-list">
        <div class="position-item" v-for="(item, index) in showPositionList" :key="index"
          @click="toPositionDetail(item)">
          <div class="top">
            <div class="post-name">{{ item.title }}</div>
            <div class="post-salary">{{ item.salary_str }}</div>
          </div>
          <div class="middle">
            <div class="address">{{ item.work_addr }}</div>
            <div class="position-name">{{ item.position }}</div>
            <div class="edu">{{ item.period }}</div>
          </div>
          <div class="bottom">
            <div class="left-company">
              <div class="company-img">
                <img :src="item.company.logo_url" alt="">
              </div>

              <div class="name">{{ item.company.company_name }}</div>
            </div>
            <div class="right">
              <div class="major">{{ item.company.second_industry }}</div>
              <div class="line"></div>
              <div class="people-num">{{ item.company.insize }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showMorePosBtn" class="more-position" @click="toMorePositionList">查看更多</div>
    </div>

  </div>
</template>

<script>
import { getHomeResource, getHomeCompanyResource, getHomePositionResource } from '@/api/indexPage.js';
import { chunk } from 'lodash'
const arrowBlue = require('@/assets/arrow_blue.png')
const arrowGray = require('@/assets/arrow_gray.png')
export default {
  name: 'NewIndex',
  data() {
    return {
      isShowFirst: true,
      bannerActiveIndex: 0,
      bannerInterval: 3000,
      bannerList: [],
      recruitHot: [],
      companyFamousList: [],
      // 招聘企业列表
      companyList: [],
      // 底部职位列表
      positionList: [],
      positionPage: 1,
      positionAllPage: '',
      showMorePosBtn: false,
      arrowBlue,
      arrowGray,
      companyIsMouse: false
    }
  },
  computed: {
    moreCompanyArrow() {
      return this.companyIsMouse ? arrowBlue : arrowGray
    },
    bannerMaxWidth() {
      return 896 / this.bannerList.length - 24
    },
    recruitHotList() {
      if (this.isShowFirst) {
        return this.recruitHot.length && this.recruitHot.slice(0, 21)
      }
      return this.recruitHot.length && this.recruitHot.slice(21)
    },
    showPositionList() {
      return this.positionList.slice(0, this.positionPage).flat(1)
    }
  },
  created() {
    this.getHomeResource()
    this.getHomeCompanyResource()
    this.getHomePositionResource()
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    // 点击更多企业
    toCompanyList() {
      const { href } = this.$router.resolve({ name: 'companyList' })
      window.open(href, '_blank')
    },
    // 点击查看更多职位
    toMorePositionList() {
      const { href } = this.$router.resolve({ name: 'JobRecommend' })
      window.open(href, '_blank')
    },
    // 顶部banner
    async getHomeResource() {
      const res = await getHomeResource()
      if (res.apiStatus) {
        const { banner_list: bannerList, company_famous_list: companyFamousList, recruit_hot: recruitHot } = res
        this.bannerList = bannerList
        this.companyFamousList = companyFamousList
        this.recruitHot = JSON.parse(recruitHot || '[]')
      }
    },
    // 招聘企业
    async getHomeCompanyResource() {
      const res = await getHomeCompanyResource()
      if (res.apiStatus) {
        this.companyList = res.list.slice(0, 39)
      }
    },
    // 招聘职位
    async getHomePositionResource() {
      const res = await getHomePositionResource()
      if (res.apiStatus) {
        this.positionList = chunk(res.list, 18)
        this.positionAllPage = this.positionList.length
      }
    },
    // 点击顶部职位类别跳转
    toPositionList(item) {
      const { href } = this.$router.resolve({
        path: '/positionList',
        query: {
          value: item.value,
          label: item.label
        }
      })
      window.open(href, '_blank')
    },
    // 点击招聘企业跳转
    toCompany({ id }) {
      const { href } = this.$router.resolve({
        path: '/companyDetailPage',
        query: {
          id,
        }
      })
      window.open(href, '_blank')
    },
    // 点击招聘职位跳转
    toPositionDetail({ id }) {
      const { href } = this.$router.resolve({
        path: '/job',
        query: {
          id
        }
      })
      window.open(href, '_blank')
    },
    // 顶部职位类别左右切换
    showPosition(to) {
      if((to == 'toRight' && this.isShowFirst) || (to == 'toLeft' &&!this.isShowFirst)) {
        this.isShowFirst = !this.isShowFirst
      }
    },
    // banner图片切换出发
    changeBanner(newIndex, oldIndex) {
      this.bannerActiveIndex = newIndex
    },
    setActiveItem(index) {
      this.bannerInterval = 5000
      setTimeout(() => {
        this.bannerInterval = 3000
      }, 5000)
      this.bannerActiveIndex = index
      const carousel = this.$refs.carouselRef;
      carousel.setActiveItem(index);
    },
    // 点击banner跳转
    toJump(url) {
      window.open(url)
    },
    handleScroll(e) {
      // 获取页面滚动的高度
      const scrollHeight = window.innerHeight + window.scrollY;
      // 获取页面内容的总高度
      const pageHeight = document.documentElement.scrollHeight;
      // 判断是否滚动到页面底部
      if (scrollHeight >= (pageHeight - 300)) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.positionPage < this.positionAllPage) {
        this.positionPage++
      } else {
        this.showMorePosBtn = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index";
</style>



// WEBPACK FOOTER //
// src/components/newIndex/index.vue